import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/login/login_logo.png'

const _withId = /*#__PURE__*/_withScopeId("data-v-78bed7f8")

_pushScopeId("data-v-78bed7f8")
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "text-center login absolute" }
const _hoisted_3 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_4 = { class: "form bg-ff" }
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "c-ff f-16" }, "登录", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_el_form, {
          "label-position": _ctx.labelPosition,
          "label-width": "80px",
          model: _ctx.form,
          rules: _ctx.rules,
          ref: "formRef"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_form_item, {
              "label-width": "0",
              prop: "account"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  "input-style": "background-color: #f4f4f4;",
                  modelValue: _ctx.form.account,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.account = $event)),
                  placeholder: "请输入账号"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              "label-width": "0",
              prop: "password"
            }, {
              default: _withId(() => [
                _createVNode(_component_el_input, {
                  "input-style": "background-color: #f4f4f4;",
                  type: "password",
                  modelValue: _ctx.form.password,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.password = $event)),
                  placeholder: "请输入密码"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { "label-width": "0" }, {
              default: _withId(() => [
                _createVNode(_component_el_button, {
                  class: "bg-red width-full",
                  onClick: _ctx.submitForm
                }, {
                  default: _withId(() => [
                    _hoisted_5
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["label-position", "model", "rules"])
      ])
    ])
  ]))
})